<template>
    <div>
        <div :style="{display:isTagShow?'block':'none'}">
            <Row>
                <p style="line-height: 24px;">法规层级:</p>
                <Col span="24">
                <div id="checkBoxCountry" style="float: left;display: inline-block;">
                    <!--  <Tag checkable color="primary" style="height：60px;width:100px;" ref="nationwide">全国</Tag> -->
                    <Button :style="{display:(isSearchEngine && version==='1') || isLocalNew || isCountryNew?'block-inline':'none'}" :disabled="nationwideDiasble" :type="nationwide?'primary':'dashed'" style="height:36px;width:100px;margin-right: 10px;" @click="nationWideChecked">中央</Button>
                    <Checkbox :style="{display:(isSearchEngine && version==='2') || isCloudNew?'block-inline':'none'}" :disabled="nationwideDiasble" v-model="nationwide" border>中央</Checkbox>
                </div>
                <!--  <div :style="{float: 'left',paddingLeft:padLeft}"> -->
                <!-- streeProvince -->
                <div style="display: flex;float:left;align-items: center;height: 40px;line-height: 40px;">省级</div>
                <MultiTag :style="{width:this.getSliders().length>0?'32%':'20%',paddingLeft: '10px'}" class="common-width1" :tData="province" :defDisabled="provenceDisable" defaultValue="请选择:省(自治区/直辖市)级文件" ref="submitProvince" @onSelected="onMultiTagSelected" @onDeSelected="onMultiTagDeSelected"></MultiTag>
                <!--    </div> -->
                 <div style="display: flex;float:left;align-items: center;height: 40px;line-height: 40px;padding-left: 10px;">市级</div>
                <div :style="{float: 'left',paddingLeft:padLeft,display:'inline-block',width:this.getSliders().length>1?'120px':(this.getSliders().length>0?'':'360px')}" class="cityContains">
                    <AutoComplete v-model="value4" icon="md-arrow-dropdown" :disabled="cityDisable" :placeholder="ph" class="common-width2" @keyup.native="handleSubmit" readonly="false">
                        <div v-if="items.length>0" style="width:360px;height: 280px;overflow: auto;">
                            <p style="padding-left: 15px;">
                                <Checkbox v-model="cityChecked" @on-change="checkedAllCities">选择/取消 所有市(地/州)</Checkbox>
                            </p>
                            <Card :bordered="false" v-for="item,index in items" :key="item.id" style="margin-top: 5px;">
                                <ReadMore ref="readMoreCpt" :nodetext="item.text" :children="item.children" @onTotalCheckedChange="totalCheckChange1"></ReadMore>
                            </Card>
                        </div>
                        <div v-else style="padding-left:10px;font-size: 12px;">
                            <Icon type="md-alert" color="orange" size="16" /> 没有数据
                        </div>
                    </AutoComplete>
                </div>
                <div :style="{float: 'left',paddingLeft:padLeft,display:'inline-block'}">
                    <Button :style="{display:version==='1' || isLocalNew?'none':'inline-block'}" type="primary" @click="confirmSelect" :disabled="submitBtnDisabled">确定</Button>
                    <!--          <Button type="primary" style="margin-left: 8px;" @click="resetlayer" :disabled="resetBtnDisabled">重选</Button> -->
                </div>
                </Col>
                <Col span="0">
                </Col>
            </Row>
            <Row>
                <p v-show="false" style="line-height: 24px;">法规分类:</p>
                <Col span="40">
                <div v-show="false">
                    <div style="float: left">
                        <TreeTag ref="firstTag" :class="this.getSliders().length>0?'common-width3':'common-width'" @tag-Select="tagSelect1" @onTagChange="onTagChange"></TreeTag>
                    </div>
                    <div :style="{float: 'left',paddingLeft:padLeft}">
                        <TreeTag ref="nextTag" @tag-Select="tagSelect2" :style="{display:tag2Disp?'block':'none'}" :class="this.getSliders().length>0?'common-width3':'common-width'" @onTagChange="onTagChange"></TreeTag>
                    </div>
                    <div :style="{float: 'left',paddingLeft:padLeft}">
                        <TreeTag ref="thirdTag" @tag-Select="tagSelect3" :style="{display:tag3Disp?'block':'none'}" :class="this.getSliders().length>0?'common-width3':'common-width'" @onTagChange="onTagChange"></TreeTag>
                    </div>
                    <div :style="{float: 'left',paddingLeft:padLeft}">
                        <TreeTag ref="fourthTag" @tag-Select="tagSelect4" :style="{display:tag4Disp?'block':'none'}" :class="this.getSliders().length>0?'common-width3':'common-width'" @onTagChange="onTagChange"></TreeTag>
                    </div>
                    <div :style="{float: 'left',paddingLeft:padLeft}">
                        <TreeTag ref="fifthTag" @tag-Select="tagSelect5" :style="{display:tag5Disp?'block':'none'}" :class="this.getSliders().length>0?'common-width3':'common-width'" @onTagChange="onTagChange"></TreeTag>
                    </div>
                    <div :style="{float: 'left',paddingLeft:padLeft,paddingTop:'2px',display:'inline-block'}">
                        <Button type="primary" @click="reset" :disabled="resetDisable">返回</Button>
                    </div>
                </div>
                <div :style="{display:isShowDeleteButton?'inline':'none',float: 'left'}">
                    <Button type="text" size="small" style="box-shadow: none;width: 65px;">
                        <font style="text-decoration:underline;" @click="deletefiles">一键删除</font>
                    </Button>
                    <Tooltip max-width="250" placement="top" theme="light" :disabled="deleteToolTipsShowDisabled" :offset="5" content="一键删除当前文件夹下的所有文件">
                        <!--  <div @click="go"> <Icon type="md-help-circle" size="16" color="#ff9900"/></div> -->
                        <Button type="text" size="large" icon="md-help-circle" style="font-size: 18px;box-shadow: none;width: 15px;" @click="deleteToolTipsShowDisabled=!deleteToolTipsShowDisabled"></Button>
                    </Tooltip>
                    <Button type="text" size="small" style="box-shadow: none;width: 65px;">
                        <font style="text-decoration:underline;" @click="openDeleteFile">选择删除</font>
                    </Button>
                    <Tooltip max-width="250" placement="top" theme="light" :disabled="deleteToolTipsShowDisabled" :offset="5" content="选择删除当前文件列表中的文件">
                        <!--  <div @click="go"> <Icon type="md-help-circle" size="16" color="#ff9900"/></div> -->
                        <Button type="text" size="large" icon="md-help-circle" style="font-size: 18px;box-shadow: none;width: 15px;" @click="deleteToolTipsShowDisabled=!deleteToolTipsShowDisabled"></Button>
                    </Tooltip>
                    <Button type="text" size="small" style="box-shadow: none;width: 158px;">
                        <font style="text-decoration:underline;" @click="deleteabolitionFiles">删除全文废止(失效)文件</font>
                    </Button>
                    <Tooltip max-width="290" placement="top" theme="light" :disabled="deleteToolTipsShowDisabled" :offset="8" content="一键删除当前文件夹下全文废止(失效)文件">
                        <!--  <div @click="go"> <Icon type="md-help-circle" size="16" color="#ff9900"/></div> -->
                        <Button type="text" size="large" icon="md-help-circle" style="font-size: 18px;box-shadow: none;width: 0px;" @click="deleteToolTipsShowDisabled=!deleteToolTipsShowDisabled"></Button>
                    </Tooltip>
                </div>
                </Col>
                <Col span="4">
                </Col>
            </Row>
        </div>
        <Row>
            <Col span="24">
            <div style="display: block;height: 10px;line-height: 10px;"></div>
            <Button :style="{display:isShowupLoadGroup?'inline':'none'}" :disabled="uploadBtnDisable" type="default" @click="uploadResult" style="box-shadow: none;">
                <Icon size="18" type="ios-cloud-upload" /> 检索结果一键上传</Button>
            <Button :style="{display:isShowupLoadGroup?'inline':'none'}" type="primary" :disabled="btnUploadStatus" @click="openUploadFile" style="box-shadow: none;margin-left: 10px;">
                {{btnTxt}}
            </Button>
            <Button type="primary" @click="selectFilesConfirm" :style="{display:btnConfirmIsShow?'inline':'none'}"  style="margin-left: 10px;">
                {{btnConfirmTxt}}
            </Button>
            </Col>
        </Row>
        <br :style="{display:deleteConfirmIsShow?'inline':'none'}" />
        <Button type="primary" @click="deleteFilesConfirm" :style="{display:deleteConfirmIsShow?'inline':'none'}">
            {{btnConfirmTxt}}
        </Button>
        <Button type="primary" @click="cancelConfirm" :style="{display:deleteConfirmIsShow?'inline':'none'}" style="margin-left: 10px;">
            取消
        </Button>
        <Spin fix v-if="spinShow1"></Spin>
        <FolderTree ref="folderTreeSelector" @onFolderSelected="onfolderSelected" @onSelectCannel="onFolderSelectCannel" />
    </div>
</template>
<script>
import TreeTag from '../../common/tag-select.vue'
import TreeMultiTag from '../../common/tree-select.vue'
import ReadMore from '../../common/readmore.vue'
import CloudFolderTree from '../../smart_cloud/showFolderTreeV2.vue'
import store from '../../../store/'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import eventBus from "../../../components/common/event_bus.js"
import testData from '../../../assets/json/selected-tree-trade.json'
import ConstJson from "../../../api/common/constjson.js"
let constJ = new ConstJson()
let parents = null
let childNode = null
let currentDeep = 0
export default {
    name: 'ResultTag',
    inject: ['getSliders'],
    props: {
        //streeProvince: Object,
        sTreeData: {
            type: Object,
            default: () => {}
        },
        sTreeIndustry: Object,
        isShowupLoadGroup: {
            type: Boolean,
            default: true,
        },
        isShowTag: {
            type: Boolean,
            default: true,
        },
        isShowDeleteButton: {
            type: Boolean,
            default: false,
        },
        isCountryVersion: {
            type: Boolean,
            default: true,
        },
        isLocalNew: {
            type: Boolean,
            default: false,
        },
        isCountryNew: {
            type: Boolean,
            default: false,
        },
        isCloudNew: {
            type: Boolean,
            default: false,
        },
        isSearchEngine: {
            type: Boolean,
            default: false,
        }

    },
    data() {
        return {
            //rid: +new Date(),
            tag2Disp: false,
            tag3Disp: false,
            tag4Disp: false,
            tag5Disp: false,
            spinShow1: false,
            classid: "",
            province: this.getProvince(),
            items: this.propsCities(), //this.sTreeData && this.sTreeData.level ? this.sTreeData.level.t3 : [], 
            totalChecked: [],
            value4: "",
            ph: "请选择:市(地/州)级文件",
            submitCity: [],
            nationwide: this.propsNationwide(),
            submitBtnDisabled: false,
            resetBtnDisabled: true,
            padLeft: "10px",
            resetDisable: false,
            folederSelectNode: {},
            checkable: false, //switch status
            btnUploadStatus: false,
            nationwideDiasble: false,
            cityDisable: false,
            provenceDisable: false,
            uploadBtnDisable: false,
            btnTxt: '检索结果选择上传',
            btnConfirmTxt: "确定(0)",
            //btnDeleteTxt:"确定(0)",
            btnConfirmIsShow: false,
            //tooltipTxt: "选择性上传已开启",
            isTipsShow: false,
            isTagShow: this.isShowTag,
            //isShowSwitchButton:true,
            //isShowUploadOneKey:true,
            //isShowUploadSelected:true,
            msg: '<div style="color:white;font-size:12px;">选择性上传已开启</div>',
            // msg: '<div style="color:white;font-size:14px;">选择性上传已开启 <a onclick="tapClick()" style="font-size:12px;color:#ffdc7c">关闭提示</a> </div>',
            deleteToolTipsShowDisabled: false,
            filesTatal: 0,
            deleteConfirmIsShow: false,
            selectedFolderId: '',
            tagpc: [],
            cityChecked: true,
            renderCityChecked: true,
            version: store.state.user.initData.currentVersion,
            //localTotal: {},
        }
    },
    created() {

        //this.getTagDefault()
        //console.log("create this.sTreeData...")
        //console.log(this.$refs.firstTag)
        //this.bindTagByWatchData(this.sTreeData)
    },
    mounted() {
        // console.log("resultTag mounted...")
        //console.log(this.sTreeData)
        if (this.sTreeData && this.sTreeData.status) {
            this.bindTagByWatchData(this.sTreeData)
        }
        //根据版本标识锁定法规层级
        if (store.state.user.initData.currentVersion === "1") {
            this.layerDisable(true)
        }
        // this.$nextTick(() => {
        //     if (store.state.user.initData.currentVersion === "2") {
        //         let r = this.getLayerData()
        //         this.$emit('on-layer-loaded', r)
        //     }
        // })

        // if (this.sTreeData && this.sTreeData.level) {
        //   this.bindLevelData(this.sTreeData.level)
        // }

        //监听模板中的html事件
        window.tapClick = () => {
            //console.log('on-tips-close...')
            // that.$emit('on-tips-close')
            //this.tipClose();
        }
    },
    components: {
        'TreeTag': TreeTag,
        'MultiTag': TreeMultiTag,
        "ReadMore": ReadMore,
        "FolderTree": CloudFolderTree,
    },
    methods: {
        //城市数据初始化
        propsCities() {
            if (this.sTreeData && this.sTreeData.level && this.sTreeData.level.t3) {
                console.log('props排序=================>')
                this.sTreeData.level.t3.sort(this.compare).slice(0)
                if (this.sTreeData.level.t3.length > 0) {
                    for (var i in this.sTreeData.level.t3) {
                        if (this.sTreeData.level.t3[i].children.length > 0) {
                            this.sTreeData.level.t3[i].children.sort(this.compare).slice(0)
                        }
                    }
                }
            } else {
                return []
            }
            return this.sTreeData.level.t3
        },
        propsNationwide() {
            // this.sTreeData && this.sTreeData.level && this.sTreeData.level.t1 && this.sTreeData.level.t1[0] ? this.sTreeData.level.t1[0].selected : true,
            let checked = false
            if (this.sTreeData && this.sTreeData.level && this.sTreeData.level.t1) {
                if (this.sTreeData.level.t1.length > 0) {
                    checked = this.sTreeData.level.t1[0].selected
                }
            }
            return checked
        },
        getProvince(da) {
            console.log('getProvince================================>')
            // console.log(da)

            let d = {}
            let newProvince = []

            if (da && da.level && da.level.t2 && da.level.t2.length > 0) {
                let items = da.level.t2
                if (items.length > 0) {
                    for (var i in items) {
                        let p = {}
                        p.id = items[i].id
                        p.label = items[i].text
                        p.selected = items[i].selected
                        newProvince.push(p)
                    }
                    d.data = newProvince
                } else {
                    d.data = null
                }
            } else if (this.sTreeData && this.sTreeData.level && this.sTreeData.level.t2) {
                let items = this.sTreeData.level.t2
                if (items.length > 0) {
                    for (var i in items) {
                        let p = {}
                        p.id = items[i].id
                        p.label = items[i].text
                        p.selected = items[i].selected
                        newProvince.push(p)
                    }
                    d.data = newProvince
                } else {
                    d.data = null
                }
            } else {
                d.data = null
            }

            // if (this.sTreeData && this.sTreeData.level && this.sTreeData.level.t2) {
            //     //console.log('|===||===============================>')


            // } else {

            // }
            // console.log('getprovince....')
            //console.log(d)
            return d
        },
        bindLevelData(da) {
            //this.value4=""
            // this.items=[{
            //     children:[],
            //     id:'',
            //     selected:false,
            //     text:'北京'
            // }]
            console.log('set t3========>')
            if (da && da.t3) {
                this.items = da.t3
                //console.log('da.t3:' + da.t3.length)
                //console.log('this.$refs.readMoreCpt.length:' + this.$refs.readMoreCpt.length)
                if (this.items.length === 0) {
                    this.ph = "请选择:市(地/州)级文件"
                    return
                }
                this.$forceUpdate();
                this.$nextTick(() => {
                    if (this.$refs.readMoreCpt && this.$refs.readMoreCpt.length > 0) {
                        let rmc = this.$refs.readMoreCpt
                        for (var i in rmc) {
                            let node = this.items.find(p => p.text === rmc[i].nodetext)
                            // console.log(node)
                            rmc[i].setChecked(node)
                        }
                    }
                })


            }

            //console.log(this.$refs.readMoreCpt)

        },
        checkedAllCities(value) {
            console.log(value)
            if (this.$refs.readMoreCpt && this.$refs.readMoreCpt.length > 0) {
                let rmc = this.$refs.readMoreCpt
                for (var i in rmc) {
                    rmc[i].handleCheckAll(value)
                }
            }
        },
        bindLevelProvince(level) {
            //this.$refs.submitProvince.loadDefault(level)
        },
        bindLevelCountry(level) {
            //this.$refs.submitProvince.loadDefault(level)
            //this.layerDisable(false)
            console.log('bindLevelCountry===============')
            if (level && level.t1 && level.t1.length === 0) {
                this.nationwideDiasble = true
                this.nationwide = false

            } else {
                if (level && level.t1 && level.t1[0]) {
                    if (this.version === "1") {
                        this.nationwideDiasble = true
                    } else if (this.version === "2") {
                        this.nationwideDiasble = false
                    } else if (this.isCloudNew) {
                        this.nationwideDiasble = false
                    }

                    var c = level.t1[0].selected
                    if (c) {
                        this.nationwide = true
                    } else {
                        this.nationwide = false
                    }
                }
            }



        },
        deleteabolitionFiles() {
            this.$emit('on-delete-abolitionfiles')
        },
        checkedDelete() {
            this.openDeleteFile()
        },
        deletefiles() {
            //console.log("gogogogo....")
            // console.log(this.selectedFolderId)
            // if(this.selectedFolderId===""){
            //   this.$Message.warning("请选择文件夹")
            //   return
            // }
            //console.log("selectedFolderId:"+this.selectedFolderId)
            //this.showDialog("提示", "", this.filesTatal)
            this.$emit('on-onekey-delete')
        },
        uploadfilesConfirm() {
            //搜索引擎一键上传,确认
            if (this.filesTatal > 0) {
                this.showDialog2("提示", "", this.filesTatal)
            } else {
                this.$Message.warning('无有效数据')
                return
            }

        },
        showMessages(type, text) {
            this.$Message[type]({
                background: true,
                content: text
            });
        },

        showDialog2(title, content, total) {
            let that = this
            this.$Modal.confirm({
                title: title,
                //content: '<p>' + content + '</p>',
                render: h => {
                    return h('span', [
                        '您确定上传此法规分类下的 ',
                        h('span', {
                            domProps: {
                                innerHTML: `<span style="font-weight:bold;color:red;font-size:16px;" >` + total + `</span> 个文件到<span style="color:#ff9900;font-size:14px;" > [智慧云端] </span>吗`,
                            }
                        }), '  ?'
                    ])
                },
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    this.PopFolderTreeV2(1)
                },
                onCancel: () => {
                    return
                    // this.$Message.info('Clicked cancel');
                }
            });
        },
        //地方版最新文件区域用于设置法规层级禁用
        setTagLevels(city) {
            console.log('setTagLevels...')
            console.log(city)
            let ps = []
            let defaultValue = []
            let province = {
                id: city.province.value ? city.province.value : city.province.id,
                label: city.province.label,
            }
            ps.push(province)
            defaultValue.push(province.id)
            //console.log(ps)
            //console.log(defaultValue)
            this.$refs.submitProvince.showProvinceAndCity(ps, defaultValue)

            this.ph = city.city ? city.city.label : '请选择:市(地/州)级文件'
            this.layerDisable(true)
            // this.$refs.submitProvince.options=ps
            // this.$refs.submitProvince.value=defaultValue
            //  this.$nextTick(() => {

            // })
            //this.$refs.submitProvince.value = province.id //['001']

        },
        selectFilesConfirm() {
            this.checkable = false
            this.change(false)
            this.showBtnTxt(0)
            this.btnTxt = "检索结果选择上传"
            this.uploadBtnDisable = false
            //交互提示
            this.$emit('on-submit-checked', this.selectedFolderId)
            //this.$Message.success("提交成功")
        },
        deleteFilesConfirm() {
            console.log('sumit deletefiles...')
            this.$emit('on-delete-checked', this.selectedFolderId)
            this.showBtnTxt(0)
            this.cancelConfirm()
        },
        cancelConfirm() {
            this.deleteConfirmIsShow = false
            this.checkable = false
            this.isTagShow = true
            this.$emit("on-show-checkbox", false) //更新视图
            this.$emit("on-submit-checked-cancel") //清除list
            this.showBtnTxt(0)
        },
        cancelUploadConfirm() {
            this.checkable = false
            if (this.isLocalNew) {
                this.isTagShow = false
            } else {
                this.isTagShow = true
            }
            this.change(false)
            this.btnTxt = "检索结果选择上传"
            this.uploadBtnDisable = false
            this.showBtnTxt(0)

            this.$emit("on-show-checkbox", false) //更新视图

        },
        //parent component calling
        showBtnTxt(digit) {
            if (digit > 0) {
                this.btnConfirmTxt = "确定(" + digit + ")"
                //this.btnUploadStatus=false
            } else if (digit === 0) {
                this.btnConfirmTxt = "确定(" + digit + ")"
                //this.btnUploadStatus=true
            } else {
                //this.btnTxt="检索结果选择上传"
                //this.btnUploadStatus=true
            }
        },
        tipClose() {
            // console.log("this.isTipsShow:"+this.isTipsShow)
            this.isTipsShow = false
        },
        layerDisable(value) {
            //层级

            this.nationwideDiasble = value
            this.nationwide = true
            // this.$refs.submitProvince.disabled = true
            this.$refs.submitProvince.setDisable(true)
            this.cityDisable = value
            this.submitBtnDisabled = false
        },
        allDisable(value) {
            //分类
            this.$refs.firstTag.disabled = value
            this.$refs.nextTag.disabled = value
            this.$refs.thirdTag.disabled = value
            this.$refs.fourthTag.disabled = value
            this.$refs.fifthTag.disabled = value
            this.resetDisable = value
            //层级
            this.nationwideDiasble = value
            this.$refs.submitProvince.disabled = value
            this.cityDisable = value
            this.submitBtnDisabled = value
            //检索结果操作组件
            this.uploadBtnDisable = value
        },
        passData(tagData) {
            var data = {
                t1: { data: tagData.t1 },
                t2: { data: tagData.t2 },
                t3: { data: tagData.t3 },
                t4: { data: tagData.t4 },
            }

            return data
        },
        uploadStatus() {
            this.btnUploadStatus = true
            this.checkable = true //同步状态
            this.$emit("on-show-checkbox", this.checkable) //触发表格多选,隐藏小贴士
            this.btnConfirmIsShow = true
            //锁定一键上传
            this.uploadBtnDisable = true

            //同步tooltip状态
            this.isTipsShow = true

            //锁定其他组件
            if (this.isCountryVersion === true) {
                this.isTagShow = true
            } else {
                this.isTagShow = false
            }

        },
        uploadDeleteStatus() {
            // this.btnUploadStatus = true
            this.deleteConfirmIsShow = true
            this.checkable = true //同步状态
            this.$emit("on-show-checkbox", this.checkable) //触发表格多选,隐藏小贴士
            //this.btnConfirmIsShow = true

            //锁定其他组件
            this.isTagShow = false
        },
        //选择上传
        openUploadFile() {
            if (this.checkAccessPromission(this.sTreeData)) {
                if (this.checkUserLogin()) {
                    //showmodal
                    if (!this.PopFolderTreeV2(2)) {
                        return
                    }
                    //update ui
                    this.btnTxt = "正在勾选..."
                    this.uploadStatus()
                    //hidden 法规层级/法规分类
                    this.isTagShow = false
                } else {
                    console.log("openUploadFile user-login")
                    eventBus.$emit("user-login", "true", "0") //临时登录
                }
            }
        },
        openDeleteFile() {
            if (this.checkUserLogin()) {
                //this.btnTxt = "正在勾选..."
                this.uploadDeleteStatus()
            } else {
                console.log("openDeleteFile user-login")
                eventBus.$emit("user-login", "true", "0") //临时登录
            }
        },
        change(status) {
            console.log("change--->" + status)
            if (!status) {
                //关闭
                this.btnUploadStatus = false
                //confirm button display
                this.btnConfirmIsShow = false
                //tooltips
                this.isTipsShow = false
                //若地方版则不显示tag
                if (this.isShowTag) {
                    this.isTagShow = true
                }

                //解锁状态
                //this.allDisable(false)
                //清除所有选择项
                //this.$emit("clean-checked")

            } else {
                //开启
                this.btnUploadStatus = true
                //confirm button display
                this.btnConfirmIsShow = true
                //tooltips
                this.isTipsShow = true
                this.isTagShow = false
                //锁定其他组件
                //this.allDisable(true)
            }
            //显示checkbox
            this.$emit("on-show-checkbox", status)

        },
        onTagChange() {
            // this.pNextSearch()
        },
        propDataInit(data, placeholder, searchable) {
            //console.log(data)
            var a = {}
            a.data = data
            a.placeholder = placeholder
            a.searchable = searchable
            return a
        },
        //弹出文件夹选择器
        PopFolderTree(type) {
            var treeData = []
            var folderData = store.state.user.folder.data.tabrows
            console.log(folderData)
            if (!folderData) {
                this.$Message.warning('沒有云端文件夹，请前往在线商城购买')
                return false
            }
            // console.log(testData.data3)
            for (var item of folderData) {
                var i = {}
                i.label = item.foldername
                i.id = item.folderid
                i.is_fixed = item.is_fixed
                i.desc = item.desc
                i._checked = item._checked
                i._disabled = item._disabled
                i.is_root = item.is_root
                treeData.push(i)
            }

            this.$refs.folderTreeSelector.bindFolderTree(treeData, type)
            return true
        },
        PopFolderTreeV2(type) {
            var treeData = []
            var folderData = store.state.user.myfolders
            if (!folderData) {
                this.$Message.warning('沒有云端文件夹，请前往在线商城购买')
                return false
            }
            console.log('PopFolderTreeV2==>')
            console.log(folderData)
            this.$refs.folderTreeSelector.bindFolderTree(folderData,type)
            return true
        },
        onFolderSelectCannel() {
            this.cancelUploadConfirm()
        },
        onfolderSelected(folderid, type) {
            //console.log(folderid,type)
            this.selectedFolderId = folderid
            //this.folederSelectNode = node
            if (type === 1) {
                this.$emit("on-one-key-upload", this.selectedFolderId)
            } else {
                //发射激活选择上传的状态,父层隐藏搜索
                this.$emit("on-folder-selected-upload")
            }



        },
        reload() {
            this.isRouterAlive = false
            //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        },

        //权限控制
        checkPermission() {
            //"000009" // 一键上传
            let rsp = false
            let checkcode = '000009'
            let permission = this.sta.permission
            if (permission && permission.length > 0) {
                let index = permission.findIndex(p => p.f === checkcode)
                console.log('checkcode.index:' + index)
                if (index >= 0) {
                    rsp = true
                }
            }
            return rsp
        },
        //检查页访问权限
        checkAccessPromission(tempData) {
            console.log(tempData)
            if (tempData.protect) {
                if (tempData.warninglevel === 1) {
                    //提示登录
                    console.log('检查页面访问权限1===>')
                    eventBus.$emit("user-login", "true", "0") //临时登录
                    return false
                } else if (tempData.warninglevel === 2) {
                    //提示去商城
                    console.log('检查页面访问权限2===>')
                    eventBus.$emit('user-nopermission-board', tempData.warningtext, 1)
                    return false
                } else if (tempData.warninglevel === 3) {
                    //提示去商城
                    console.log('检查页面访问权限2===>')
                    eventBus.$emit('user-nopermission-board', tempData.warningtext, 2)
                    return false
                }
            } else {
                return true
            }


        },
        uploadResult() {
            console.log('检查一键上传！')

            //判断是否有访问文件的权限
            console.log(this.sTreeData)
            if (this.checkAccessPromission(this.sTreeData)) {
                //检查一键上传权限,修改为从接口判断
                //检查接口权限
                let code = this.$Tools.getPermission().CODE_FUNC_UPLOAD
                let name = "一键上传"
                let po = {
                    funccode: code,
                    funcname: name,
                }
                this.checkUserPermission(po, 4)
            }


        },
        // uploadResult1() {
        //     console.log('检查一键上传！')
        //     //检查一键上传权限,修改为从接口判断
        //     let accountstatus = this.sta.accountstatus
        //     if (!this.checkPermission()) {
        //         if (accountstatus === 100) {
        //             eventBus.$emit('user-nopermission-board', '要获得一键上传权限,请前去在线商城购买账号等级')
        //             return
        //         } else if (accountstatus === 200) {
        //             eventBus.$emit('user-nopermission-board', '要获得一键上传权限,请前去在线商城购买VIP升级权限')
        //             return
        //         }
        //     }

        //     if (this.checkUserLogin()) {
        //         console.log('checkUserLogin....')
        //         //console.log('isLocalNew:' + this.isLocalNew)
        //         if (this.isLocalNew) {
        //             console.log('isLocalNewUpload===>')
        //             this.$emit('show-local-upload')
        //         } else {
        //             console.log('isSeachEngineUpload===>')
        //             this.uploadfilesConfirm()
        //         }

        //         //showmodal
        //         // if (store.state.user.initData.currentVersion === "1") {
        //         //     this.uploadfilesConfirm()
        //         // } else {
        //         //     this.$emit('show-local-upload')
        //         // }
        //         //this.PopFolderTree(1)
        //         //this.$emit("on-one-key-upload")
        //     } else {
        //         //store.commit("setLoginForm", true)
        //         console.log('uploadResult user-login')
        //         eventBus.$emit("user-login", "true") //临时登录
        //     }
        // },
        //检查接口访问权限，验证成功则访问，验证失败则提示
        //fType,=1上传云端,=2普通下载,=3云擎下载,=4一键上传
        checkUserPermission(po, fType) {
            constJ.reqCheckUserPromission(po).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (!res.result.protect) {
                            if (fType === 1) {

                            } else if (fType === 2) {
                                //访问普通下载
                                if (this.orderid === 1) {
                                    var strdocid = this.text
                                    constJ.reqDownLoadOneFile(strdocid, undefined, this.showMessage)
                                } else if (this.orderid === 2) {
                                    this.showDownLoadFiles(this.text)
                                }
                            } else if (fType === 3) {
                                //访问云擎下载
                                if (this.orderid === 1) {
                                    var strdocid = this.text
                                    constJ.reqDownLoadFile(strdocid, undefined, this.showMessage)
                                } else if (this.orderid === 2) {
                                    //this.showDownLoadFiles(this.text)
                                }
                            } else if (fType === 4) {
                                //访问一键上传
                                if (this.isLocalNew) {
                                    console.log('isLocalNewUpload===>')
                                    this.$emit('show-local-upload')
                                } else {
                                    console.log('isSeachEngineUpload===>')
                                    this.uploadfilesConfirm()
                                }
                            }
                        } else {
                            if (res.result.warninglevel === 1) {
                                //登录
                                eventBus.$emit("user-login", "true", "0") //临时登录
                                return
                            } else if (res.result.warninglevel === 2) {
                                //去商城账号等级
                                eventBus.$emit('user-nopermission-board', res.result.warningtext, 1)
                                return
                            } else if (res.result.warninglevel === 3) {
                                //去商城升级vip
                                eventBus.$emit('user-nopermission-board', res.result.warningtext, 2)
                                return
                            } else {
                                console.log('待处理的警告等级===>' + res.result.warninglevel)
                                return
                            }
                        }

                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {
                // this.$Message.error(err.rtndesc);
                // return
            })
        },
        checkUserLogin() {
            if (store.state.user.userId === undefined || store.state.user.userId === "") {
                return false
            } else {
                return true
            }
        },
        tagSelect(node) {
            var rawData = this.sTreeData.data
            //console.log(rawData[0].children)
            this.getChildNode(rawData[0].children, node.id, 1)
            //console.log(parents)
            if (node.children != null) {
                this.tag2Disp = true
                let obj = this.propDataInit(node.children, '', false)
                this.$refs.nextTag.bindData(obj)
            }
            this.$refs.firstTag.disabled = true
            this.pNextSearch()
            //console.log(node)
            //this.sTreeIndustry=this.getIndustryData(node)
            //console.log(this.sTreeIndustry)
        },

        tagSelect1(node) {
            // if (this.td.t2.data.length > 1) {
            //   this.tag2Disp = true
            // }
            this.pNextSearch(node)

        },

        tagSelect2(node) {
            // if (this.td.t3.data.length > 1) {
            //   this.tag3Disp = true
            // }
            this.pNextSearch(node)
        },

        tagSelect3(node) {
            // if (this.td.t4.data.length > 1) {
            //   this.tag4Disp = true
            // }
            this.pNextSearch(node)
        },

        tagSelect4(node) {
            this.pNextSearch(node)
        },
        tagSelect5(node) {
            this.pNextSearch(node)
        },


        nextTagSelect(node) {
            if (node.children != null) {
                this.tag3Disp = true

                let obj = this.propDataInit(node.children, '', false)
                this.$refs.thirdTag.bindData(obj)
                // this.$refs.thirdTag.bindData(node.children,'',false)
            }
            this.$refs.nextTag.disabled = true
            this.pNextSearch()
            //console.log(node)
            //this.sTreeIndustry=this.getIndustryData(node)
            //console.log(this.sTreeIndustry)
        },
        thirdTagSelect(node) {
            this.$refs.thirdTag.disabled = true
            this.pNextSearch()
        },
        pNextSearch(node) {
            //console.log("tag select node id:"+node.id)
            this.totalChecked = []
            console.log('p============>')
            this.value1 = "1"
            this.spinShow1 = true
            var that = this
            setTimeout(function() {
                that.spinShow1 = false
                //演示
                // that.$refs.search_rlt.changePage()
                that.$emit('onTagchanged', node)
            }, 900)
        },
        //tag回退
        reset() {
            // console.log("reset...")
            //console.log(this.sTreeData)
            // if (this.tag4Disp) {
            //   this.tag4Disp = false
            //   //console.log(this.$refs.nextTag.options[0])
            //   this.pNextSearch(this.$refs.nextTag.options[0])
            // } else if (this.tag3Disp) {
            //   this.tag3Disp = false
            //   this.pNextSearch(this.$refs.firstTag.options[0])
            //   //console.log(this.$refs.nextTag.options)
            // } else if (this.tag2Disp) {
            //   this.tag2Disp = false
            //   this.pNextSearch('')
            //   //console.log(this.$refs.firstTag.options)
            // }

            // this.totalChecked = []
            // this.ph = "请选择:市(地/州)级文件"
            // this.submitCity = []

            var minlock = this.sTreeData.status.minlock
            if (minlock === 5) {
                this.pNextSearch(this.$refs.fourthTag.options[0])
            } else if (minlock === 4) {
                this.pNextSearch(this.$refs.thirdTag.options[0])
            } else if (minlock === 3) {
                this.pNextSearch(this.$refs.nextTag.options[0])
            } else if (minlock === 2) {
                this.pNextSearch(this.$refs.firstTag.options[0])
            } else if (minlock === 1) {
                this.pNextSearch("")
            }



        },
        getChildNode(treeNodes, nodepid, deep) {
            if (!treeNodes || !treeNodes.length) return;
            for (var i = 0; i < treeNodes.length; i++) {
                if (parents && parents.id == nodepid || nodepid == "pptr") {
                    return;
                }
                var childs = treeNodes[i].children;
                //console.log("treeid:"+treeNodes[i].id+"\r\nnodepid:"+nodepid)
                if (treeNodes[i].id == nodepid) {
                    childNode = treeNodes[i].children;
                    return;
                } else {
                    if (childs && childs.length > 0) {
                        if (currentDeep > deep) {
                            return
                        } else {
                            this.getChildNode(childs, nodepid, deep);
                            currentDeep++
                        }

                    }
                }

            }
        },

        // totalCheckChange1() {
        //     this.submitCity=[]
        //     var dispCity = [] //显示的数据
        //     let cityChecked = [] //显示的数据
        //     let citySubmit = [] //提交的数据
        //     if (this.$refs.readMoreCpt && this.$refs.readMoreCpt.length > 0) {
        //         let rmc = this.$refs.readMoreCpt
        //         for (var i in rmc) {
        //             var oneCard = rmc[i].checkDispGroup
        //             var oneCities = rmc[i].checkAllGroup
        //             for (var i in oneCard) {
        //                 cityChecked.push(oneCard[i])
        //             }
        //             console.log('cityChecked='+cityChecked.length)
        //             for (var i in oneCities) {
        //                 citySubmit.push(oneCities[i])
        //             }
        //             console.log('citySubmit='+citySubmit.length)
        //         }
        //         this.submitCity = citySubmit
        //     }

        //     dispCity = cityChecked
        //     if (dispCity.length > 2) {
        //         let showCity = dispCity.slice(0, 2)
        //         let showLength = dispCity.length - 2
        //         this.ph = showCity.sort().join() + ",更多+" + showLength + ""
        //     } else {
        //         this.ph = dispCity.sort().join()
        //     }
        //     if (dispCity.length === 0) {
        //         this.ph = "请选择:市(地/州)级文件"
        //     }
        //     this.activeSubmitBtn()
        // },


        //方法2
        // totalCheckChange2(nodeItems) {
        //     this.joinItems2(nodeItems)
        // },
        // joinItems2(nodeItems) {
        //      let city = [] //需要提交到后端查询的城市集合
        //     //动态替换用户选择数组
        //     console.log("joinItems====>"+nodeItems.items.length)
        //     console.log(nodeItems)
        //     let index = this.totalChecked.findIndex(item => item.name === nodeItems.name)
        //     //console.log(index)
        //     if (index >= 0) {
        //         this.totalChecked.splice(index, 1, nodeItems)
        //     } else {
        //         this.totalChecked.push(nodeItems)
        //     }

        //     //构建用户选择的城市对象集合
        //     this.totalChecked.forEach(function(item) {
        //         if (item.items.length > 0) {
        //             item.items.forEach(function(item) {
        //                 //去重
        //                 let index = city.findIndex(p => p.id === item.id)
        //                 if (index < 0) {
        //                     city.push(item)
        //                 }

        //             })
        //         }
        //     })
        //     //城市去重
        //     //city = Array.from(new Set(city))
        //     //console.log(city)
        //     this.submitCity = city;
        //     //console.log(city)
        //     //console.log(this.submitCity)
        //     //构建需要显示的城市数组
        //     let dispCity = []
        //     city.forEach(function(item) {
        //         dispCity.push(item.text)
        //     })

        //     //var tag="<Tag checkable color='primary'>全国</Tag>"
        //     //中文数组排序
        //     dispCity = dispCity.sort(function compare(a, b) {
        //         return a.localeCompare(b)
        //     })
        //     if (dispCity.length > 2) {
        //         let showCity = dispCity.slice(0, 2)
        //         let showLength = dispCity.length - 2
        //         //this.value4=dispCity.join()+"..."
        //         //console.log(dispCity)
        //         this.ph = showCity.join() + ",更多+" + showLength + ""
        //     } else {
        //         //this.value4=dispCity.join()
        //         this.ph = dispCity.join()
        //     }
        //     if (dispCity.length === 0) {
        //         this.ph = "请选择:市(地/州)级文件"
        //     }
        //     this.activeSubmitBtn()
        //     console.log("after joinitems,count totalChecked==>")
        //     console.log(this.totalChecked)
        // },



        totalCheckChange1(nodeItems) {
            let city = [] //需要提交到后端查询的城市集合
            this.joinItems(nodeItems)
            //console.log(this.totalChecked.length)

            //构建用户选择的城市对象集合
            this.totalChecked.forEach(function(item) {
                if (item.items.length > 0) {
                    item.items.forEach(function(item) {
                        //去重
                        let index = city.findIndex(p => p.id === item.id)
                        if (index < 0) {
                            city.push(item)
                        }

                    })
                }
            })
            //城市去重
            //city = Array.from(new Set(city))
            //console.log(city)
            this.submitCity = city;
            //console.log(city)
            //console.log(this.submitCity)
            //构建需要显示的城市数组
            let dispCity = []
            city.forEach(function(item) {
                dispCity.push(item.text)
            })

            //var tag="<Tag checkable color='primary'>全国</Tag>"
            //中文数组排序
            dispCity = dispCity.sort(function compare(a, b) {
                return a.localeCompare(b)
            })
            if (dispCity.length > 2) {
                let showCity = dispCity.slice(0, 2)
                let showLength = dispCity.length - 2
                //this.value4=dispCity.join()+"..."
                //console.log(dispCity)
                this.ph = showCity.join() + ",更多+" + showLength + ""
            } else {
                //this.value4=dispCity.join()
                this.ph = dispCity.join()
            }
            if (dispCity.length === 0) {
                this.ph = "请选择:市(地/州)级文件"
            }
            //console.log('submitcity========================')
            //console.log(this.submitCity)
            this.activeSubmitBtn()
            //console.log('totalCheckChange==============complete!')

        },
        joinItems(nodeItems) {
            //动态替换用户选择数组
            // console.log("joinItems====>" + nodeItems.items.length)
            // console.log(nodeItems)
            let index = this.totalChecked.findIndex(item => item.name === nodeItems.name)
            //console.log(index)
            if (index >= 0) {
                this.totalChecked.splice(index, 1, nodeItems)
            } else {
                this.totalChecked.push(nodeItems)
            }
            // console.log("after joinitems,count totalChecked==>")
            // console.log(this.totalChecked)
        },
        handleSubmit(val) {
            //console.log(val)
            this.value4 = ""
        },
        nationWideChecked() {
            this.nationwide = !this.nationwide
            //this.activeSubmitBtn()
        },
        nationWideChecked1() {
            console.log("222222222222222222222222")
            // if (this.version === "1") {
            //     this.nationwide = true
            // } else {
            //     this.nationwide = value
            // }

            //this.nationwide = !this.nationwide
            //this.activeSubmitBtn()
        },
        getLayerData() {
            console.log(this.sTreeData)
            let tpc = []
            let postStrs = []
            if (!this.nationwideDiasble && this.nationwide && this.sTreeData.level.t1 && this.sTreeData.level.t1.length > 0) {
                postStrs.push(this.sTreeData.level.t1[0].id)
            }
            if (this.submitCity && this.submitCity.length > 0) {
                let citys = this.submitCity
                for (var i in citys) {
                    postStrs.push(citys[i].id)
                }
            }
            if (this.$refs.submitProvince.value) {
                postStrs = postStrs.concat(this.$refs.submitProvince.value)
            }
            //this.tagpc=postStrs
            for (var i in postStrs) {
                var items = postStrs[i]
                if (items && items.length === 12) {
                    var one = {
                        p: postStrs[i].substr(0, 6),
                        c: postStrs[i].substr(6, 12),
                    }
                }
                tpc.push(one)
            }
            return tpc
        },
        confirmSelect() {
            //重置auto complete
            //this.rid = +new Date()

            this.totalChecked = []
            var r = this.getLayerData()
            this.tagpc = r
            console.log(this.tagpc)
            console.log(this.submitCity.length)
            //console.log(postStrs)
            this.$emit('set-tagpc', this.tagpc)
            // this.cityDisable = true
            // this.nationwideDiasble = true
            // this.$refs.submitProvince.setDisable(true)
            // this.submitBtnDisabled = true
            //this.resetBtnDisabled = false
        },
        // resetlayer() {
        //     this.cityDisable = false
        //     this.nationwideDiasble = false
        //     this.$refs.submitProvince.setDisable(false)
        //     this.submitBtnDisabled = false
        //     //this.resetBtnDisabled = true
        // },
        activeSubmitBtn() {
            this.submitBtnDisabled = false
        },
        onMultiTagSelected(node) {
            console.log(node)
            this.activeSubmitBtn()
        },
        onMultiTagDeSelected(node) {
            // console.log(node)
            this.activeSubmitBtn()
        },
        bindTagByWatchData(da) {
            // console.log("da.status.minlock..." + da.status.minlock)
            // console.log('bindTagByWatchData-------------------')
            // console.log(da)
            this.resetDisable = false
            this.tag2Disp = false
            this.tag3Disp = false
            this.tag4Disp = false
            this.tag5Disp = false
            if (da.status.minlock === da.status.minback) {
                this.resetDisable = true
            }
            if (da.status.minlock === 0 || da.status.minlock === undefined) {
                //2020-02-26修改,数据t1=空也需要绑定
                this.$refs.firstTag.bindDataTag(da.tags.t1, false)
                // if (da.tags.t1.length > 0) {
                //   this.$refs.firstTag.bindDataTag(da.tags.t1, false)
                // }
            }

            if (da.status.minlock === 1) {
                this.$refs.firstTag.bindDataTag(da.tags.t1, true)
                if (da.tags.t2.length > 0) {
                    this.$refs.nextTag.bindDataTag(da.tags.t2, false)
                    this.tag2Disp = true
                }
                // if(da.status.minback===1){
                //   this.resetDisable=true
                // }
            }
            if (da.status.minlock === 2) {
                // console.log(da.tags.t1[0])
                // console.log(da.tags.t2[0])
                this.$refs.firstTag.bindDataTag(da.tags.t1, true)
                this.$refs.nextTag.bindDataTag(da.tags.t2, true)
                if (da.tags.t3.length > 0) {
                    this.$refs.thirdTag.bindDataTag(da.tags.t3, false)
                    this.tag3Disp = true
                }
                // if(da.status.minback===2){
                //   this.resetDisable=true
                // }

                //this.$refs.fourthTag.bindDataTag(da.tags.t4, false)
                this.tag2Disp = true
            }
            if (da.status.minlock === 3) {
                this.$refs.firstTag.bindDataTag(da.tags.t1, true)
                this.$refs.nextTag.bindDataTag(da.tags.t2, true)
                this.$refs.thirdTag.bindDataTag(da.tags.t3, true)
                if (da.tags.t4.length > 0) {
                    this.$refs.fourthTag.bindDataTag(da.tags.t4, false)
                    this.tag4Disp = true
                }
                // if(da.status.minback===3){
                //   this.resetDisable=true
                // }
                this.tag2Disp = true
                this.tag3Disp = true


            } else if (da.status.minlock === 4) {
                this.$refs.firstTag.bindDataTag(da.tags.t1, true)
                this.$refs.nextTag.bindDataTag(da.tags.t2, true)
                this.$refs.thirdTag.bindDataTag(da.tags.t3, true)
                this.$refs.fourthTag.bindDataTag(da.tags.t4, true)
                //add 5
                if (da.tags.t5.length > 0) {
                    this.$refs.fifthTag.bindDataTag(da.tags.t5, false)
                    this.tag5Disp = true
                }

                this.tag2Disp = true
                this.tag3Disp = true
                this.tag4Disp = true
            } else if (da.status.minlock === 5) {
                this.$refs.firstTag.bindDataTag(da.tags.t1, true)
                this.$refs.nextTag.bindDataTag(da.tags.t2, true)
                this.$refs.thirdTag.bindDataTag(da.tags.t3, true)
                this.$refs.fourthTag.bindDataTag(da.tags.t4, true)
                this.$refs.fifthTag.bindDataTag(da.tags.t5, true)
                this.tag2Disp = true
                this.tag3Disp = true
                this.tag4Disp = true
                this.tag5Disp = true
            }
            this.filesTatal = da.total

            //console.log('da.total==============================',da.total)
            // if (da.localTotal) {
            //     this.localTotal = da.localTotal
            // }






        },
        compare(a, b) {
            const aid = parseInt(a.id.substr(0, 6))
            const bid = parseInt(b.id.substr(0, 6))
            let rlt = 0
            if (aid > bid) {
                rlt = 1
            } else if (aid < bid) {
                rlt = -1
            }
            return rlt
        }

    },
    computed: {
        ...mapGetters(['getUserId', 'sta']),
    },
    watch: {
        sTreeData: {
            //immediate: true,
            handler(val) {
                // console.log("sTreeData handler===>")
                // console.log(val)
                //绑定法规分类
                this.bindTagByWatchData(val)
                //重新绑定城市数据
                if (val.level && val.level.t3) {
                    //console.log(JSON.stringify(val.level.t3))
                    console.log('排序=================>')
                    val.level.t3.sort(this.compare).slice(0)
                    if (val.level.t3.length > 0) {
                        for (var i in val.level.t3) {
                            if (val.level.t3[i].children.length > 0) {
                                val.level.t3[i].children.sort(this.compare).slice(0)
                            }
                        }
                    }
                    //console.log(val.level.t3)
                    this.bindLevelData(val.level)
                }
                //绑定/刷新并显示省级数据
                if (val.level && val.level.t2) {
                    val.level.t2.sort(this.compare).slice(0)
                    this.province = this.getProvince(val)
                    //this.bindLevelProvince(val.level)
                }
                //绑定国家级tag
                if (val.level) {
                    this.bindLevelCountry(val.level)
                }
                //选择tag:有数据则显示
                if (val.status.minlock === 1) {
                    this.$refs.firstTag.disabled = true

                }
                if (val.status.minlock === 2) {
                    this.$refs.nextTag.disabled = true
                    this.tag2Disp = true

                }
                if (val.status.minlock === 3) {
                    this.$refs.thirdTag.disabled = true
                    this.tag3Disp = true

                }
                if (val.status.minlock === 4) {
                    this.$refs.fourthTag.disabled = true
                    this.tag4Disp = true

                }
                if (val.status.minlock === 5) {
                    this.$refs.fifthTag.disabled = true
                    this.tag5Disp = true

                }

            }
        },
    }
}
</script>
<style scoped>
/*tool tips*/
.center-right {
    float: right;
}

.common-width1 {
    display: inline-block;
    /*width: 30%;*/
    float: left;
}

.common-width2 {
    /*width: 360px;*/
    display: inline-block;
    float: left;
}

.common-width {
    display: inline-block;
    width: 250px;
}

.common-width3 {
    display: inline-block;
    width: 200px;
    /* width: 250px;*/
}

.common-width/deep/.ivu-input {
    height: 36px;
}

.common-width2/deep/.ivu-input {
    height: 36px;
}

.demo-spin-container {
    display: inherit;
    width: auto;
    height: auto;
    position: relative;
    /* border: 1px solid #eee;*/
}

.cityContains>>>.ivu-input-large {
    color: #c5c8ce;
}

.autoCityList {}
</style>
<style lang="less" scoped>
//@import "../style/tooltips.scss"

#checkBoxCountry .ivu-checkbox-border {
    height: 35px;
    line-height: 35px;
}
</style>